import { createReducer, on } from '@ngrx/store';
import * as CommunitiesActions from './communities.actions';
import { CommunitiesState } from './communities.state';
import { ICommunity } from '../model/community.model';
import { IUser } from '../../user/model/user.model';

export const initialCommunitiesState: CommunitiesState = {
  communities: [] as ICommunity[],
  pendingCommunities: [] as ICommunity[],
  searchResults:[] as IUser[],
  selectedCommunities: [] as string[]
};
 
export const communitiesReducer = createReducer(
    initialCommunitiesState,
    on( CommunitiesActions.communitiesActions.getCommunitiesSuccess, (state , { communities }) => ({ 
      ...state, 
      communities: communities
    })),
    on( CommunitiesActions.communitiesActions.deleteCommunitySentSuccess, (state , { community }) => ({ 
      ...state, 
      communities: [...state.communities.filter(x => x.id !== community.id)]
    })),
    on( CommunitiesActions.communitiesActions.searchCommunitySentSuccess, (state , { searchResults }) => ({ 
      ...state, 
      searchResults: searchResults
    })),
    on( CommunitiesActions.communitiesActions.getPendingCommunitySuccess, (state , { communities }) => ({ 
      ...state, 
      pendingCommunities: communities
    })),
    on( CommunitiesActions.communitiesActions.createCommunitySuccess, (state , { community }) => ({ 
      ...state, 
      communities: [...state.communities, community]
    })),
    on( CommunitiesActions.communitiesActions.selectCommunity, (state , { communityId }) => ({ 
      ...state, 
      selectedCommunities: [...state.selectedCommunities.filter(x => x !== communityId), communityId]
    })),
    on( CommunitiesActions.communitiesActions.unselectCommunity, (state , { communityId }) => ({ 
      ...state, 
      selectedCommunities: [...state.selectedCommunities.filter(x => x !== communityId)]
    })) 
);
